import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const rootElement = document.getElementById("root");
const isWidgetRoute = window.location.pathname.startsWith("/widget/");

if (isWidgetRoute && rootElement) {
  document.documentElement.style.background = "transparent";
  document.documentElement.style.backgroundColor = "transparent";
  document.documentElement.style.margin = "0";
  document.documentElement.style.width = "100%";
  document.documentElement.style.height = "100%";

  document.body.style.background = "transparent";
  document.body.style.backgroundColor = "transparent";
  document.body.style.margin = "0";
  document.body.style.width = "100%";
  document.body.style.height = "100%";
  document.body.style.overflow = "hidden";

  rootElement.style.background = "transparent";
  rootElement.style.margin = "0";
  rootElement.style.padding = "0";
  rootElement.style.width = "100%";
  rootElement.style.height = "100%";
  rootElement.style.maxWidth = "none";
}

createRoot(rootElement!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
